import { ExpertRole } from "../../../utils/Enums";

interface ExpertInfo {
    name: string;
    familyName: string;
    role: ExpertRole;
}

export const EXPERT_INFO_MAP: Record<string, ExpertInfo> = {
    "elvira.pistolesi@holifya.com": {
        name: "Elvira",
        familyName: "Pistolesi",
        role: ExpertRole.Specialist
    },
    "dr.gentilesalvatore@gmail.com": {
        name: "Salvatore",
        familyName: "Gentile",
        role: ExpertRole.Physician
    },
    "filippobonaldi91@gmail.com": {
        name: "Filippo",
        familyName: "Bonaldi",
        role: ExpertRole.Physician
    },
    "alessandra.piccione91@gmail.com": {
        name: "Alessandra",
        familyName: "Piccione",
        role: ExpertRole.Physician
    },
    "ccruciani44@gmail.com": {
        name: "Cristina",
        familyName: "Cruciani",
        role: ExpertRole.Nutritionist
    },
    "tsimbatatiana@gmail.com": {
        name: "Tatiana",
        familyName: "Tsimbata",
        role: ExpertRole.Nutritionist
    },
    "fabiana.nutrizionista@gmail.com": {
        name: "Fabiana",
        familyName: "Nutrizionista",
        role: ExpertRole.Nutritionist
    },
    "eleonoraluvara.nutrizionista@gmail.com": {
        name: "Eleonora",
        familyName: "Luvarà",
        role: ExpertRole.Nutritionist
    },
    "carolinacolonna94@gmail.com": {
        name: "Carolina",
        familyName: "Colonna",
        role: ExpertRole.Nutritionist
    },
    "admin@holifya.com": {
        name: "Olivia",
        familyName: "Olivietti",
        role: ExpertRole.Nutritionist
    }
};

/**
 * Get expert information (name, family name, role) from email
 * @param email - The expert's email address
 * @returns ExpertInfo object or null if not found
 */
export const getExpertInfo = (email: string): ExpertInfo | null => {
    if (!email) return null;
    return EXPERT_INFO_MAP[email.toLowerCase()] || null;
};

/**
 * Get expert's full name from email
 * @param email - The expert's email address
 * @returns Full name string or null if not found
 */
export const getExpertFullName = (email: string): string | null => {
    const expertInfo = getExpertInfo(email);
    if (!expertInfo) return null;
    return `${expertInfo.name} ${expertInfo.familyName}`;
};

/**
 * Get expert's first name from email
 * @param email - The expert's email address
 * @returns First name string or null if not found
 */
export const getExpertName = (email: string): string | null => {
    const expertInfo = getExpertInfo(email);
    return expertInfo?.name || null;
};

/**
 * Get expert's family name from email
 * @param email - The expert's email address
 * @returns Family name string or null if not found
 */
export const getExpertFamilyName = (email: string): string | null => {
    const expertInfo = getExpertInfo(email);
    return expertInfo?.familyName || null;
};

/**
 * Get expert's role from email
 * @param email - The expert's email address
 * @returns ExpertRole or null if not found
 */
export const getExpertRole = (email: string): ExpertRole | null => {
    const expertInfo = getExpertInfo(email);
    return expertInfo?.role || null;
};

/**
 * Check if an email belongs to an expert
 * @param email - The email address to check
 * @returns boolean indicating if the email belongs to a known expert
 */
export const isExpertEmail = (email: string): boolean => {
    return email.toLowerCase() in EXPERT_INFO_MAP;
}; 